var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 24 24","role":"presentation","focusable":"false","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}},[_c('path',{attrs:{"d":"M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }